import React, { useContext, useEffect, useRef, useState } from "react";
import Table from "../../components/table/table";
import { UserContext } from "../../contexts/UserContext";
import { GetListSimulations } from "../../helpers/api";
import { io } from "socket.io-client";
import Call from "../../assets/icons/Call.svg";
import CallAlert from "../../assets/icons/CallAlert.svg";
import { BASE_URL_SOCKET } from "../../helpers/config";
import { useActionMap } from "../../hooks/useActionMap";
import { list } from "postcss";


export default function FirstHomeContainer() {
  const { user } = useContext(UserContext);
  const {setRetardCall} = useContext(UserContext)
  const [apiResponse, setApiResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [now, setNow] = useState(new Date());
  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const actionMap = useActionMap();


  const socketRef = useRef(null)
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!user?.accessToken) return;

    const socket = io(BASE_URL_SOCKET, {
      auth: {
        userId: user.user.id,
        role: user.user.role,
      },
    });

    socketRef.current= socket

    socket.on("connect", () => {
      console.log("Connecté à Socket.IO, id:", socket.id);
    });

    // Événement : Ajout ou Mise à jour
    socket.on("upsertSimulation", (simulation) => {
    if (simulation.agentId !== null && simulation.agentId!==user.user.id )
    return;

      setTotalPage(prev=> prev  + 1);
      setApiResponse((prev) => {
        
        const index = prev.findIndex((s) => s.id === simulation.id);
        if (index !== -1) {
          // Mise à jour : on remplace l'existante
          const newData = [...prev];
          newData[index] = simulation;
          return newData;
        } else {
          // Ajout : on l'ajoute au début de la liste
          return [simulation, ...prev];
        }
      });
    });

    socket.on('agentAssigned', (data) => {
      if(data.agentAssignedId === user.user.id) return

      setApiResponse((prev) => prev.filter((s) => s.userId !== data.clientId))  
      
})

    // Événement : Suppression (Conditions non respectées)
    // socket.on("deleteSimulation", (data) => {
    //   console.log("deletesimulationId", data);

    //   setApiResponse((prev) => prev.filter((s) => s.id !== data.id));
    // });

    // Événement : Suppression après appel par un agent
    // socket.on("deleteSimulationAgent", ({ simulationId }) => {

//       socket.on("deleteSimulationAgent", ({ clientId }) => {
//   console.log("clientId socket =", clientId);

//   setApiResponse((prev) => {
//     console.log("prev =", prev);

//     return prev.filter((s) => {
//       console.log("s.id =", s.id);

//       return s.id !== clientId;
//     });
//   });
// });

// Delete simulation completed
  socket.on("actionComplete", ({simulationId }) => {
            setTotalPage(prev=> prev - 1);
      setApiResponse((prev) => prev.filter((s) => s.id !== simulationId ))  
    });


    socket.on("deleteSimulationAgent", ({clientId }) => {
            setTotalPage(prev=> prev - 1);

      setApiResponse((prev) => prev.filter((s) => s.userId !== clientId ))  
    });

    // Cleanup à la fermeture du composant
    return () => {
      socket.disconnect();
    };
  }, [user?.accessToken]);


  useEffect(() => {
    const fetchData = async () => {
      try { 
        const response = await GetListSimulations(
          user?.accessToken,
          currentPage,
          pageSize,
          user.user.id
        );
        if (response?.success) {
          //  const liste = response.simulations.filter((item)=>
          //   (item.agentId === user.user.id || item.agentAssignedId === user.user.id ) || (!item.agentId && ! item.agentAssignedId))
           setApiResponse(response.simulations || []);

          setTotalPage(response?.total);
          setIsLoading(false);
           

        }
      } catch (error) {
        console.error("Error:", error);
        setIsLoading(false);
      }
    };
    if (user?.accessToken) fetchData();
  }, [user?.accessToken, pageSize, currentPage]);

 
// Calcul du nombre d'appels en retard
  useEffect(() => {
    const retardUsers = apiResponse.filter((item) => {

      const createdTime = new Date(item.createdAt).getTime()

      return (now.getTime() - createdTime) / 60000 >= 5
    })

    setRetardCall(retardUsers.length)

    localStorage.setItem(
      'retardCall',
      JSON.stringify(retardUsers.length)
    )
  }, [apiResponse, now])


  const handleCall = (row) => {
    // const socket = io(BASE_URL_SOCKET);
     const socket= socketRef.current
     if(!socket) return

    socket.emit("callSimulation", {
      simulationId: row.id,
      agentId: user?.user?.id,
      clientId: row?.userId,
      simulationType: row?.action,
    });
    console.log('callSimulation', socket)
    setTotalPage(prev=> prev - 1);

    // Optionnel : On peut aussi supprimer localement immédiatement pour la réactivité
    setApiResponse((prev) => prev.filter((s) => s.userId !== row.userId));

  };

  const columns = [
    {
      label: "Order",
      key: "order",
      customRenderers: (row) => (
        <div className="flex flex-col items-start ">
          <span>{row.order}</span>
          {(now - new Date(row.createdAt)) / 60000 >= 5 && (
            <span className="text-[8px] font-bold  text-[#FF3B30] animate-pulse ">
              RETARD +5 MIN
            </span>
          )}
        </div>
      ),
    },
    {
      label: "Nom du Client",
      key: "firstName",
      customRenderers: (row) => (
        <div>
          <a
            href={`/detailuser/${row.userId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#777777] underline  hover:text-blue-800"
            onClick={(e) => {
              localStorage.setItem(
                "varaction",
                JSON.stringify({ actionId: row.id, actionType: row.action }),
              );
              e.stopPropagation();
            }}
          >
            {row.firstName} {row.lastName}
          </a>
        </div>
      ),
    },
    {
      label: "Email",
      key: "email",
      customRenderers: (row) => <div>{row.email}</div>,
    },
    {
      label: "Pays",
      key: "countryName",
      customRenderers: (row) => <div>{row.countryName}</div>,
    },
    {
      label: "Téléphone",
      key: "phone",
      customRenderers: (row) => <div>{row.phone}</div>,
    },
    {
      label: "Date & heure",
      key: "date",
      customRenderers: (row) => {
        const date = new Date(row.createdAt);

        const formattedDate = date.toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleString("fr-FR", {
          hour: "2-digit",
          minute: "2-digit",
        });

        return (
          <div>
            {formattedDate} <br />
            {formattedTime}
          </div>
        );
      },
    },
    {
      label: "Action",
      key: "action",
      customRenderers: (row) => {
        const actionItem = actionMap[row.action];
        return (
          <>
            {actionItem && (
              <div className="text-left flex items-center gap-2 bg-white rounded-[40px] h-[32px] shadow-[0px_2px_10px_rgba(0,0,0,0.15)] text-[#000] text-[12px] px-2">
                <img src={actionItem.icon} alt="" /> {actionItem.type}
              </div>
            )}
          </>
        );
      },
    },
    {
      label: "Appeler",
      key: "Appeler",
      customRenderers: (row) => (
        <div className="flex justify-start px-2">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleCall(row);
            }}
          >
            {(now - new Date(row.createdAt)) / 60000 >= 5 ? (
              <img src={CallAlert} alt="Appel client" />
            ) : (
              <img src={Call} alt="Appel client" />
            )}
          </button>
        </div>
      ),
    },
     {
      label: "statut",
      key: "id",
      customRenderers: (row) => (
        <div className="flex justify-start px-2">
          {!row.agentId ? 'Nouveau' : 'existant'}
         
         
        </div>
      ),
    },
  ];


  return (
    <div className=" min-h-screen w-full font-sans">
      <div className="bg-white rounded-xl shadow-2xl border border-[#EEEEEE] w-full p-4 md:p-6 overflow-hidden">
        <Table
          totalPage={totalPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setPageLimit={setPageSize}
          pageLimit={pageSize}
          data={apiResponse}
          columns={columns}
          loading={isLoading}
          excel={true}
          rowClassName={(row) => {
            const diff = (now - new Date(row.createdAt)) / 60000;
            return diff >= 5
              ? " border-l-4 border-l-[#FF3B30]"
              : "border-l-4  border-l-[#5754E5]";
          }}
        />
      </div>
    </div>
  );
}
